// src/components/EscrowBanner.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './EscrowBanner.css';
import { useEscrowBanner } from '../context/EscrowBannerContext';

export default function EscrowBanner() {
  const navigate = useNavigate();
  const { src, isLoaded, naturalSize, ensurePreloaded } = useEscrowBanner();
  const [ready, setReady] = useState(isLoaded);

  useEffect(() => {
    if (isLoaded) {
      setReady(true);
    } else {
      ensurePreloaded().then(() => setReady(true));
    }
  }, [isLoaded, ensurePreloaded]);

  // Reserve space to avoid layout jump while the image loads
  const aspectStyle =
    naturalSize.width && naturalSize.height
      ? { aspectRatio: `${naturalSize.width} / ${naturalSize.height}` }
      : undefined;

  return (
    <div
      className="escrow-banner"
      onClick={() => navigate('/escrow')}
      role="button"
      aria-label="Learn about BarterFi Escrow"
    >
      <div className="escrow-banner-aspect" style={aspectStyle}>
        {ready ? (
          <img
            src={src}
            alt="BarterFi Escrow — Learn how your orders are protected"
            className="escrow-banner-img show"
            loading="eager"
            decoding="sync"
          />
        ) : (
          <div className="escrow-banner-skel" />
        )}
      </div>
    </div>
  );
}
